



































































import Vue from 'vue';
import { SnackMessage } from '@/plugins/utils';
import { EventBus } from '@/plugins/eventBus';
import { Theme } from '@/plugins/theme';
import AppMenu from '@/components/AppMenu.vue';
import IdvChoices from '@/components/IdvChoices.vue';

export default Vue.extend({
  name: 'App',
  components: {
    AppMenu,
    IdvChoices,
  },
  data: () => ({
    logo: '',
    barColor: '',
    title: '',
    drawer: false,
    snackbar: false,
    cookie: false,
    gdpr: false,
    message: {
      text: '',
      timeout: 5000,
      context: 'primary',
    },
  }),
  computed: {
    theme() {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light';
    },
  },
  methods: {
    onMessage(msg: SnackMessage) {
      if (msg.context) {
        this.message.context = msg.context;
      } else {
        this.message.context = 'info';
      }
      if (msg.text) {
        this.message.text = msg.text;
      }
      if (msg.timeout) {
        this.message.timeout = msg.timeout;
      }
      this.snackbar = true;
    },
    onRaw(msg: SnackMessage) {
      const raw = document.querySelector('#raw');
      if (raw) {
        raw.innerHTML = msg.text;
      }
    },
    onAuth(msg: SnackMessage) {
      if (msg.context === 'error') {
        if (this.$store.getters.session) {
          this.$store.dispatch('CLEAR_ALL');
        }
      }
      this.onMessage(msg);
    },
    themeChanged(): void {
      const theme = this.$store.getters.theme;
      this.barColor = theme.headerColor;
      this.logo = theme.logo;
      this.title = theme.title;
    },
    getVersion(): void {
      const apiVer = require('../public/js/version.json');
      if (apiVer) {
        const verDev = document.querySelector('#versionDev');
        if (verDev) {
          verDev.setAttribute('value', `${apiVer.version} as of ${apiVer.date}`);
        }
      }
    },
  },
  mounted() {
    EventBus.$on('message', (msg: SnackMessage) => {
      this.onMessage(msg);
    });
    EventBus.$on('raw', (msg: SnackMessage) => {
      this.onRaw(msg);
    });
    EventBus.$on('auth', (msg: SnackMessage) => {
      this.onAuth(msg);
    });
    EventBus.$on('theme', () => {
      this.themeChanged();
    });
    EventBus.$on('closeDrawer', () => {
      this.drawer = false;
    });
    if (!this.$store.getters.hasAgreed) {
      this.cookie = true;
    }
    const them = this.$store.getters.theme;
    this.logo = them.logo;
    this.barColor = them.headerColor;
    this.title = them.title;
    this.getVersion();
  },
});
